"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var compact_1 = __importDefault(require("lodash/compact"));
exports.default = (function (props) {
    var address = props.address, showCountry = props.showCountry;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'font-lighter', style: { fontSize: '14px' } },
            address.firstName,
            " ",
            address.lastName,
            react_1.default.createElement("br", null),
            address.company && (react_1.default.createElement(react_1.default.Fragment, null,
                address.company,
                react_1.default.createElement("br", null))),
            (0, compact_1.default)([address.address1, address.address2]).join(', '),
            react_1.default.createElement("br", null),
            address.city,
            ", ",
            address.state,
            " ",
            address.zip,
            showCountry && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("br", null),
                address.country)))));
});
